import type { Movie } from '@/pages/home/types';

interface MovieCardProps {
  movie: Movie;
  onOpenGenre?: (genre: string) => void;
}

export default function MovieCard({ movie, onOpenGenre }: MovieCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 555电影片库`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-3">
          <span className="rounded-md bg-primary-500/95 px-2 py-1 text-xs font-medium text-background-50">
            {movie.rating} 分
          </span>
          {movie.free ? (
            <span className="rounded-md bg-accent-500/95 px-2 py-1 text-xs font-medium text-background-50">
              免费
            </span>
          ) : (
            <span className="rounded-md bg-secondary-900/80 px-2 py-1 text-xs font-medium text-background-50">
              {movie.kind === 'tv' ? '剧集' : '电影'}
            </span>
          )}
        </div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-foreground-950/70 to-transparent" />
        <span className="absolute bottom-2 left-3 right-3 text-xs font-label text-background-50">
          {movie.region} · {movie.year} · {movie.duration}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950">
          {movie.title}
        </h3>
        <p className="line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {movie.blurb}
        </p>
        <div className="mt-auto flex flex-wrap gap-2 pt-2">
          <button
            type="button"
            onClick={() => onOpenGenre && onOpenGenre(movie.genre)}
            className="cursor-pointer rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
          >
            {movie.genre}
          </button>
          {movie.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-600"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}